import { useCallback } from 'react'
import { ReactComponent as CancelIcon } from 'assets/icons/cancel.svg'
import ActionButton from 'components/ActionButton'
import IconWrapper from 'components/IconWrapper'
import useSuccessToast from 'hooks/toast/useSuccessToast'
import RejectModal from 'modals/RejectModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'
import styled from 'styled-components'
import { bodyPrimaryColor, primaryBackgroundColor } from 'styles/styleVariables'

type CancelOtcButtonProps = {
  orderId: string
  otcProductId: string
  sku: string
  onRejected?: () => void
  isReadOnly?: boolean
}

const CancelOtcButton = ({
  orderId,
  otcProductId,
  sku,
  onRejected,
  isReadOnly = false,
}: CancelOtcButtonProps): JSX.Element => {
  const { showModal } = useModalContext()
  const showSuccess = useSuccessToast()

  const showRejectModal = useCallback(() => {
    showModal(() => (
      <RejectModal
        showDescription
        description={`Select a reject reason for "Otc: ${sku}"`}
        itemId={orderId}
        otcProductId={otcProductId}
        isOtc={true}
      />
    ))
  }, [showModal])

  return (
    <StyledActionButton
      data-testid="reject"
      disabled={isReadOnly}
      icon={
        <RejectIconWrapper title="Reject Otc">
          <CancelIcon fill={bodyPrimaryColor} />
        </RejectIconWrapper>
      }
      onClick={showRejectModal}
    />
  )
}

const RejectIconWrapper = styled(IconWrapper)`
  display: flex;
  grid-column: removeIcon;
  svg {
    fill: #999999;
  }
`

const StyledActionButton = styled(ActionButton)`
  background-color: ${primaryBackgroundColor};
  margin: 1px 0px 0px -3px;
  padding: 0 5px 0 2px;
  border-radius: 4px;
  grid-column: rejectFill;
}
`
export default CancelOtcButton
